// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['fi_FI']  = {
  "name": "fi_FI",
  "day": {
    "abbrev": [
      "su",
      "ma",
      "ti",
      "ke",
      "to",
      "pe",
      "la"
    ],
    "full": [
      "sunnuntai",
      "maanantai",
      "tiistai",
      "keskiviikko",
      "torstai",
      "perjantai",
      "lauantai"
    ]
  },
  "month": {
    "abbrev": [
      "tammi",
      "helmi",
      "maalis",
      "huhti",
      "touko",
      "kesä",
      "heinä",
      "elo",
      "syys",
      "loka",
      "marras",
      "joulu"
    ],
    "full": [
      "tammikuu",
      "helmikuu",
      "maaliskuu",
      "huhtikuu",
      "toukokuu",
      "kesäkuu",
      "heinäkuu",
      "elokuu",
      "syyskuu",
      "lokakuu",
      "marraskuu",
      "joulukuu"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d.%m.%Y",
  "time24": "%H.%M.%S",
  "dateTime": "%a %e. %Bta %Y %H.%M.%S",
  "time12": "",
  "full": "%a %-d.%-m.%Y %H.%M.%S %z"
}

